import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import TableHeader from "../layout/table/TableHead";
import { data } from "../../../assets/data/distributors";

import moment from "moment";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

import { Link, useNavigate } from "react-router-dom";
import { getComparator, stableSort } from "../../../utils/tableSort";
import TablePagination from "../layout/table/TablePagination";
import { MdOutlineCancel } from "react-icons/md";

const headCells = [
  {
    id: "id",
    label: "Distributor ID",
  },
  {
    id: "date",
    label: "Fetcha creado",
  },
  {
    id: "name",
    label: "Nombre del distributor",
  },
  {
    id: "image",
    label: "Imagen",
  },
];

export default function DistributorTable() {
  const [order, setOrder] = useState("asc");
  const [showDelete, setShowDelete] = useState(false);
  const [orderBy, setOrderBy] = useState("calories");
  const [page, setPage] = useState(0);
  const [visibleRows, setVisibleRows] = useState([]);

  const rowsPerPage = 5;

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data.length) : 0;

  useEffect(() => {
    const sortedRows = stableSort(data, getComparator(order, orderBy));
    const slicedRows = sortedRows.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
    setVisibleRows(slicedRows);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, order, orderBy, page, rowsPerPage]);

  return (
    <Box sx={{ width: "100%" }}>
      {showDelete && (
        <div className="fixed h-screen w-screen bg-black/30 top-0 left-0 z-20 flex pt-52 justify-center">
          <div className="relative w-[500px] h-[200px] bg-[white] text-center rounded-xl p-10">
            <button onClick={() => setShowDelete(false)} className="absolute top-3 right-3">
              <MdOutlineCancel className="text-2xl text-basic-red" />
            </button>

            <p>
              <span>Desea eliminar permanentemente el distributor</span>
              <br />
              <span className="text-basic-red font-semibold">
                distributor
              </span>
              ?
            </p>

            <div className="mt-10 flex gap-5 justify-center">
              <button
                onClick={() => setShowDelete(false)}
                className="drop-shadow-lg px-8 py-2 bg-[white] rounded"
              >
                Cancelar
              </button>
              <button className="drop-shadow-lg px-8 py-2 bg-basic-red rounded text-[white]">
                Eliminar
              </button>
            </div>
          </div>
        </div>
      )}
      <Paper sx={{ width: "100%", mb: 2 }}>
        <TableContainer sx={{ borderRadius: 2 }} className="font-gotham-light">
          <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
            <TableHeader
              headCells={headCells}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={data.length}
            />
            <TableBody>
              {visibleRows.map((row, i) => {
                return (
                  <TableRow
                    key={i}
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    sx={{
                      cursor: "pointer",
                    }}
                    className="hover:bg-basic-red hover:font-semibold"
                  >
                    <TableCell scope="row">{row.id}</TableCell>
                    <TableCell className="underline">
                      <Link to={"/order/" + row.id}>
                        {moment(row.date).format("DD MMMM YYYY, h:mm A")}
                      </Link>
                    </TableCell>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>
                      <div className="flex items-center">
                        <img
                          width={60}
                          src={row.image}
                          alt="product"
                        />
                        <LongMenu setShowDelete={setShowDelete} />
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
              {emptyRows > 0 && (
                <TableRow>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          data={data}
          rowsPerPage={rowsPerPage}
          page={page}
          handleChangePage={handleChangePage}
        />
      </Paper>
    </Box>
  );
}

const ITEM_HEIGHT = 48;

function LongMenu({ setShowDelete }) {

  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreHorizIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: "20ch",
          },
        }}
      >
        <MenuItem onClick={() => navigate("/view-distributor/1")}>
          <p className="font-gotham-medium text-sm text-basic-red italic">
            Ver detaile
          </p>
        </MenuItem>
        {/* <MenuItem onClick={() => navigate("/product-edit/1")}>
          <p className="font-gotham-medium text-sm">Editar</p>
        </MenuItem> */}
        <MenuItem onClick={() => {
          setShowDelete(true)
          setAnchorEl(null);
        }}>
          <p className="font-gotham-medium text-sm">Eliminar</p>
        </MenuItem>
      </Menu>
    </div>
  );
}
